export const getHeroCTAVisibility = ({ heroCTA, leadPartnershipModule, heroImage }) => {
  const hasValidHeroCTA = Boolean(
    heroCTA && heroCTA.title && heroCTA.button_url && heroCTA.button_text
  )

  const hasLeadPartnershipModuleContent = Boolean(
    leadPartnershipModule?.section_1 || leadPartnershipModule?.section_2
  )

  const showToolCTAWithHero = Boolean(
    hasValidHeroCTA && !hasLeadPartnershipModuleContent && heroImage
  )

  const showLeadPartnershipModule = Boolean(
    hasLeadPartnershipModuleContent && !heroCTA && heroImage
  )

  const heroToolCta = showToolCTAWithHero ? heroCTA : undefined

  return {
    showToolCTAWithHero,
    showLeadPartnershipModule,
    heroToolCta,
  }
}
